// loginUser.js
import axios from 'axios';
import { BASE_URL } from '../../utils/constants';
import { handleApiError } from '../../utils/handleApiError';

const API_URL = '/users/auth/login/';

export const loginUser = async (email, password) => {
    const fullAPIUrl = `${BASE_URL}${API_URL}`;

    try {
        const response = await axios.post(fullAPIUrl, { email, password });
        return response.data;
    } catch (error) {
        handleApiError(error)
    }
};
